// vant 2.12.27 未自带 vi-VN 语言包，此包按 vant/lib/locale/lang/zh-CN.js 的完整 key 树补齐
export default {
  name: 'Tên',
  tel: 'Điện thoại',
  save: 'Lưu',
  confirm: 'Xác nhận',
  cancel: 'Hủy',
  delete: 'Xóa',
  complete: 'Hoàn thành',
  loading: 'Đang tải...',
  telEmpty: 'Vui lòng nhập số điện thoại',
  nameEmpty: 'Vui lòng nhập họ tên',
  nameInvalid: 'Họ tên không hợp lệ',
  confirmDelete: 'Bạn có chắc muốn xóa không',
  telInvalid: 'Số điện thoại không hợp lệ',
  vanCalendar: {
    end: 'Kết thúc',
    start: 'Bắt đầu',
    title: 'Chọn ngày',
    confirm: 'Xác nhận',
    startEnd: 'Bắt đầu/Kết thúc',
    weekdays: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    monthTitle: function monthTitle(year, month) {
      return 'Tháng ' + month + ' năm ' + year
    },
    rangePrompt: function rangePrompt(maxRange) {
      return 'Chọn không quá ' + maxRange + ' ngày'
    }
  },
  vanCascader: {
    select: 'Vui lòng chọn'
  },
  vanContactCard: {
    addText: 'Thêm liên hệ'
  },
  vanContactList: {
    addText: 'Thêm liên hệ mới'
  },
  vanPagination: {
    prev: 'Trước',
    next: 'Sau'
  },
  vanPullRefresh: {
    pulling: 'Kéo xuống để làm mới...',
    loosing: 'Thả ra để làm mới...'
  },
  vanSubmitBar: {
    label: 'Tổng cộng:'
  },
  vanCoupon: {
    unlimited: 'Không giới hạn',
    discount: function discount(_discount) {
      return 'Giảm ' + (100 - _discount * 10) + '%'
    },
    condition: function condition(_condition) {
      return 'Đơn từ ' + _condition
    }
  },
  vanCouponCell: {
    title: 'Phiếu giảm giá',
    tips: 'Không có phiếu khả dụng',
    count: function count(_count) {
      return 'Còn ' + _count + ' phiếu'
    }
  },
  vanCouponList: {
    empty: 'Chưa có phiếu giảm giá',
    exchange: 'Đổi',
    close: 'Không sử dụng phiếu',
    enable: 'Khả dụng',
    disabled: 'Không khả dụng',
    placeholder: 'Nhập mã phiếu'
  },
  vanAddressEdit: {
    area: 'Khu vực',
    postal: 'Mã bưu chính',
    areaEmpty: 'Vui lòng chọn khu vực',
    addressEmpty: 'Vui lòng nhập địa chỉ chi tiết',
    postalEmpty: 'Mã bưu chính không hợp lệ',
    defaultAddress: 'Đặt làm địa chỉ mặc định',
    telPlaceholder: 'Số điện thoại người nhận',
    namePlaceholder: 'Họ tên người nhận',
    areaPlaceholder: 'Chọn tỉnh / thành / quận'
  },
  vanAddressEditDetail: {
    label: 'Địa chỉ chi tiết',
    placeholder: 'Số nhà, đường, tầng, phòng...'
  },
  vanAddressList: {
    add: 'Thêm địa chỉ mới'
  }
}
